export const RunRatRowsData = [
  {
    metric: "spend",
    name: "SPEND",
  },
  {
    metric: "clicks",
    name: "CLICKS",
  },
  {
    metric: "cvr",
    name: "CVR%",
  },
  {
    metric: "ftd",
    name: "FTD",
  },
  {
    metric: "CPA_Income",
    name: "CPA INCOME",
  },
  {
    metric: "RS_Income",
    name: "RS INCOME",
  },
  {
    metric: "TOTAL_Income",
    name: "TOTAL INCOME",
  },
  {
    metric: "profit",
    name: "PROFIT",
  },
  {
    metric: "cpc",
    name: "CPC",
  },
  {
    metric: "CAC",
    name: "CAC",
  },
  {
    metric: "NRPU",
    name: "NRPU",
  },
  {
    metric: "CPA_PV",
    name: "CPA PV",
  },
  {
    metric: "RS_PV",
    name: "RS PV",
  },
  {
    metric: "pv",
    name: "PV",
  },
];
